import { AppState } from 'src';
import { Dispatch, connect } from 'react-redux';
import { OptionsViewModel } from '@models/common.models';
import { DynamicSelectIdentifier, ModalProps } from '@common/components';
import {
  TradePriceAgreementComponentProperties,
  TradePriceAgreementComponent
} from './trade-price-agreement.component';
import { searchPriceAgreements, savePriceAgreement } from '../../vendor-dashboard/vendor-dashboard.actions';
import { toggleModal } from '@common/components/common.actions';
import { PriceAgreementViewModel } from '@models/Vendor';

function mapStateToProps(
  state: AppState,
  ownProps: { id: number; isTab?: boolean; readOnly?: boolean }
): Partial<TradePriceAgreementComponentProperties> {
  return {
    id: ownProps.id,
    message: state.vendorMaintenance.message,
    priceAgreementsSearchQuery: state.vendorMaintenance.priceAgreementsSearchQuery,
    priceAgreementsSearchLoading: state.vendorMaintenance.priceAgreementsSearchLoading,
    priceAgreementsSearchPageCount: state.vendorMaintenance.priceAgreementsSearchPageCount,
    priceAgreementsSearchPageNumber: state.vendorMaintenance.priceAgreementsSearchPageNumber,
    priceAgreementsSearchPageSize: state.vendorMaintenance.priceAgreementsSearchPageSize,
    priceAgreementsSearchResults: state.vendorMaintenance.priceAgreementsSearchResults,
    priceAgreementsSearchResultsTotalCount: state.vendorMaintenance.priceAgreementsSearchResultsTotalCount,

    cviFilter: state.vendorMaintenance.cviFilter,
    paymentType: state.vendorMaintenance.paymentType,
    cviOptions: state.dynamicSelect.options[DynamicSelectIdentifier.CVIs] || ([] as Array<OptionsViewModel>)
  };
}

function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: { id: number; isTab?: boolean; readOnly?: boolean }
): Partial<TradePriceAgreementComponentProperties> {
  return {
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    searchPriceAgreements: (id, query, pageNumber, pageSize, filterBy, orderBy, orderDirection, filters) =>
      dispatch(searchPriceAgreements(id, query, pageNumber, pageSize, filterBy, orderBy, orderDirection, filters)),
    savePriceAgreement: (vendorId: number, agreement: PriceAgreementViewModel, callback: Function) => {
      dispatch(savePriceAgreement(vendorId, agreement, callback));
    }
  };
}

export const TradePriceAgreement = connect(
  mapStateToProps,
  mapDispatchToProps
)(TradePriceAgreementComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/_components/trade-price-agreement.container.ts